<template>
  <div>
    <base-overlay :show="fetching">
      <!-- <b-form
        novalidate
        @submit.prevent="submit"
      >
        <validation-observer ref="formRef"> -->
      <b-card>
        <b-form
          v-for="(docType, ix) in documentTypes"
          :key="docType.id"
          novalidate
          @submit.prevent="submit"
        >
          <validation-observer :ref="`form-${ix}`">
            <b-row
              class="px-1"
            >
              <b-col md="12">
                <div class="d-flex align-items-center">
                  <h4 class="mr-2">
                    {{ docType.name.en + " " + ` (${docType.required ? 'Required' : 'Optional'})` }}
                  </h4>
                  <div
                    v-if="docType.documentUrl"
                    class="d-flex align-items-center"
                  >
                    <h6
                      class="mb-0 mr-1"
                    >
                      Old File:
                    </h6>
                    <b-button
                      class="p-0"
                      size="sm"
                      variant="flat-primary"
                      @click="viewDocument(docType.documentUrl)"
                    >
                      Click here to view
                    </b-button>
                  </div>
                </div>
              </b-col>
              <b-col md="3">
                <validation-provider
                  #default="{ errors }"
                  :name="`${docType.name.en} file`"
                  :rules="docType.required ? 'required' :''"
                >
                  <b-form-group
                    label="File"
                    :label-for="`file-${docType.name.en}`"
                  >
                    <b-form-file
                      :id="`file-${docType.name.en}`"
                      v-model="docType.file"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="3">
                <validation-provider
                  #default="{ errors }"
                  :name="`${docType.name.en} Effective Date`"
                  :rules="docType.required || (!docType.required && docType.file) ? 'required' :''"
                >
                  <b-form-group
                    label="Effective Date"
                    :label-for="`effectiveDate-${docType.name.en}`"
                  >
                    <b-form-datepicker
                      :id="`effectiveDate-${docType.name.en}`"
                      v-model="docType.effectiveDate"
                      :disabled="!docType.required && !docType.file"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="3">
                <validation-provider
                  #default="{ errors }"
                  :name="`${docType.name.en} Expiry Date`"
                  :rules="docType.required || (!docType.required && docType.file) ? 'required' :''"
                >
                  <b-form-group
                    label="Expiry Date"
                    :label-for="`expiryDate-${docType.name.en}`"
                  >
                    <b-form-datepicker
                      :id="`expiryDate-${docType.name.en}`"
                      v-model="docType.expirationDate"
                      :disabled="!docType.required && !docType.file"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                md="3"
                class="d-flex justify-content-center align-items-center"
              >
                <b-button
                  variant="primary"
                  :disabled="docType.uploadingDocument || docType.documentUploaded"
                  @click="uploadDocument(`form-${ix}`,docType)"
                >
                  Upload
                </b-button>
                <b-spinner
                  v-if="docType.uploadingDocument"
                  small
                  variant="primary"
                />
                <template v-if="docType.uploadingDocument == false">
                  <feather-icon
                    v-if="docType.documentUploaded"
                    icon="CheckIcon"
                    class="text-success"
                  />
                  <feather-icon
                    v-if="docType.rejectedDocument && !docType.documentUploaded"
                    icon="XIcon"
                    class="text-danger"
                  />
                </template>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
        <!-- <b-button
              :disabled="submitting"
              class="ml-1"
              type="submit"
              variant="primary"
            >
              Submit documents
            </b-button> -->
      </b-card>
    </base-overlay>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BRow, BCol, BFormFile, BForm, BCard, BFormDatepicker, BFormGroup, BButton, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from 'axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BaseOverlay,
    BRow,
    BCol,
    BCard,
    BFormFile,
    BSpinner,
    BFormGroup,
    BButton,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BForm,
  },
  props: {
    businessId: {
      type: String,
      required: true,
      // default: '2dfd727c-47fe-4b9b-8d47-ca90778b6de4',
    },
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const fetching = ref(false)
    const documentTypes = ref([])
    const businessDocumentTypes = async () => {
      try {
        const res = await ctx.root.$store.dispatch('business/getAllDocumentTypes', {
          params: {
            perPage: 30,
            resourceType: 'BUSINESS',
          },
        })
        documentTypes.value = res.data.data.map(doc => ({
          ...doc,
          documentUploaded: false,
          file: null,
          effectiveDate: null,
          expirationDate: null,
          uploadingDocument: undefined,
          rejectedDocument: false,
        }))
      } catch (err) {
        // eslint-disable-next-line no-alert
        alert('Error occured while fetching document types')
      }
    }

    const uploadDocument = async (refKey, document) => {
      const res = await ctx.refs[refKey][0].validate()
      if (!res) return
      // eslint-disable-next-line no-param-reassign
      document.uploadingDocument = true
      try {
        const preSignedResponse = await ctx.root.$store.dispatch('business/getDocumentPresignedUrl', {
          businessId: props.businessId,
        })
        const { url, key } = preSignedResponse.data.data
        await axios.put(url, document.file)
        const effectiveDate = new Date(document.effectiveDate)
        effectiveDate.setHours(0, 0, 0, 0)

        const expiryDate = new Date(document.expirationDate)
        effectiveDate.setHours(0, 0, 0, 0)

        await ctx.root.$store.dispatch('business/createDocument', {
          body: {
            extension: document.file.type.slice(0, 10),
            documentKey: key,
            effectiveDate: effectiveDate.toISOString(),
            expirationDate: expiryDate.toISOString(),
          },
          businessId: props.businessId,
          documentTypeId: document.id,
        })

        // eslint-disable-next-line no-param-reassign
        document.documentUploaded = true
        successNotification(`${document.name.en} uploaded successfully`)
      } catch (err) {
        // eslint-disable-next-line no-param-reassign
        document.rejectedDocument = true
        console.log(err, 'Error')
        errorNotification(`An error occured while uploading ${document.name.en} try again`)
      } finally {
        // eslint-disable-next-line no-param-reassign
        document.uploadingDocument = false
      }
    }

    const getBusinessDocuments = async () => {
      const res = await ctx.root.$store.dispatch('business/getDocuments', {
        id: props.businessId,
      })
      const { data } = res.data
      documentTypes.value = documentTypes.value.map(docType => {
        const typeFoundInDocs = data.find(d => d.documentType.id === docType.id)
        if (typeFoundInDocs) {
          return {
            documentUploaded: false,
            file: null,
            effectiveDate: null,
            expirationDate: null,
            uploadingDocument: undefined,
            rejectedDocument: false,
            ...typeFoundInDocs.documentType,
            ...typeFoundInDocs,
          }
        }
        return {
          ...docType,
          documentUploaded: false,
          file: null,
          effectiveDate: null,
          expirationDate: null,
          uploadingDocument: undefined,
          rejectedDocument: false,
        }
      })
    }
    const viewDocument = url => window.open(url)

    const init = async () => {
      fetching.value = true
      await businessDocumentTypes()
      await getBusinessDocuments()
      fetching.value = false
    }
    init()
    return {
      fetching,
      uploadDocument,
      documentTypes,
      viewDocument,
      required,
    }
  },
}
</script>

  <style>

  </style>
